<template>
    <div class="toolbar sticky">
        <div class="wrapper clearfix">
            <!-- <div class="hotline">
                LABSEEK商城：400-623-8666
            </div> -->
            <div class="sub" style="display: flex;align-items: center;">
                <span ref="shopCar" class="scroll-car-num" @click="goShopcar" style="display: flex;align-items: center;">
                    <!-- <el-icon size="18"><ShoppingCartFull /></el-icon>
                    <i class="el-icon-shopping-cart-1" style="color: #0075c7; font-size: 14px; font-weight: bold;margin-left:3px"></i> -->
                    <img src="@/assets/icon/shopcar.png" alt="" style="width:30px">
                    购物车 
                </span>
                <span v-if="istoken == ''" style="display: flex;align-items: center;">
                        <img src="@/assets/icon/user-20.png" alt="" style="height:22px">
                        <span>
                            <router-link style="color:#FFF;text-decoration: none;" to="/login">登录</router-link>
                        </span>
                        <span style="margin: 0 1px; color: #FFF;">/</span>
                        <span style="margin: 0">
                            <router-link style="color:#fff;text-decoration: none;" to="/login?type=register">注册</router-link>
                        </span>
                </span>
                <span v-if="istoken !== ''" style="display: flex;">
                    <span v-if="mklUserInfo !== undefined" style="color: #FFF; text-decoration: none; cursor: text;display: flex;align-items: center;">
                        <span style="display: flex;align-items: center;cursor: pointer;" @click="goUser">
                            <!-- <el-icon  size="17" style="margin-right:3px"><User /></el-icon> -->
                            <img src="@/assets/icon/user-20.png" alt="" style="height:22px">
                            <span style="text-decoration: none;">{{ mklUserInfo.userName }}</span> 
                        </span>
                        </span>
                                    <span style="margin: 0 2px; color: #FFF;" v-if="mklUserInfo.userName && mklUserInfo.userName !== ''"></span>
                                    <span style="margin: 0">
                            <span class="logout" @click="logout">退出</span>
                            <!-- <span class="personal" style="margin-left:10px;color:#0066BA;font-weight: 600;" @click="()=>router.push('/profileInfo')">个人中心</span> -->
                    </span>
                </span>
                <!-- <span @click="goMyOrder">| 我的LABSEEK</span> -->
            </div>
        </div>
    </div>
</template>

<script  setup>
import {ref,watch,onMounted,computed} from "vue"
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import {ElIcon} from 'element-plus'
import { ShoppingCartFull,User } from '@element-plus/icons-vue'
import api from '@/axios/api'
const istoken = ref('')
const router = useRouter();
const route = useRoute();
const store = useStore();

function goShopcar(){
router.push({path: "/cart"})
}
function goUser(){
router.push({path: "/profileInfo"})
}
function    logout() {
    localStorage.removeItem('MklUserToken');
    api.Login.logoutApi().then((res) => {
        if (res.data.code === 200) {
            router.push('/')
        }
    })
}

const shopcarNum = computed(() => store.state.shopcartnum);
const mklUserInfo = computed(() => store.state.mklUserInfo);

watch(() => route.path, (newVal) => {
  istoken.value = localStorage.getItem('MklUserToken') ? localStorage.getItem('MklUserToken') : ''
})
onMounted(() => {
  istoken.value = localStorage.getItem('MklUserToken')? localStorage.getItem('MklUserToken') : ''
})
</script>

<style scoped>
.clearfix:after {
    content: "";
    height: 0;
    line-height: 0;
    display: block;
    visibility: hidden;
    clear: both;
}

.toolbar {
    /* background: -webkit-gradient(linear, left top, left bottom, from(#fcfdff), to(#dcdddf)); */
    background: linear-gradient(100deg, #0096CC, #0066BA );
    font-size: 12px;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index:999
}

.sticky {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    left: 0;
}

@supports (position: fixed) {
    .toolbar {
   background: linear-gradient(100deg, #0096CC, #0066BA );
        font-size: 12px;
        position: fixed;
        width: 100%;
        top: 0;
        left: 0;
    }
}

@supports (position: sticky) {
    .toolbar {
   background: linear-gradient(100deg, #0096CC, #0066BA );
        font-size: 12px;
        width: 100%;
        position: -webkit-sticky;
        position: sticky;
        left: 0;
        top: 0;
    }
}

.wrapper {
    width: 1200px;
    margin: auto;
    line-height: 28px;
}

.hotline {
    float: left;
}

.sub {
    float: right;
}

.sub > span {
    /* margin-left: 14px; */
    cursor: pointer;
    color: #FFF;
    margin-left:10px
}

.sub > span > a {
    color: #FFF;
}

.sub .logout:hover {
    text-decoration: underline
}
.personal:hover {
    text-decoration: underline 
}
</style>
